import React, {Component} from 'react';
import ResultBox from '../components/result-box';
import PopUp from '../components/pop-up';
import Loading from '../components/loading';
import configure from '../configure';

import HiddenForm from '../components/hidden-form'

export default class App extends Component {
  componentDidMount() {
    let timer = setInterval(function() {
      if($('.result-box .photo').length > 0){
        $('.result-box .photo').matchHeight();
        clearInterval(timer);
      }
    }, 10);

    setTimeout(function() {
      $.fn.matchHeight._update();
    }, 800);

  }

  componentWillMount() {
    this.props.init();
  }

  render() {
    let boxes = [];
    if(!this.props.items.length)return null;
    this.props.items.forEach((item,key)=>{
      boxes.push(
        <ResultBox
          id={key}
          key={key}
          data={item}
          sendData={this.props.sendData}
          selectedDate={this.props.selectedDate}
          selectDate={this.props.selectDate}
        />
      );
    });

    return (
      <div>
        <div id="peanuts">
          <div className="result-area">
            <h1 className="title">{this.props.date.month}.{this.props.date.date} の検索結果</h1>
            <div className="result-cover">
              {boxes}
            </div>
          </div>
        </div>
        <PopUp
          sendData={this.props.sendData}
          selectedId={this.props.selectedId}
          selectedDate={this.props.selectedDate}
          items={this.props.items}
        />
        <HiddenForm
          data={this.props.selectedDate}
          saveFormRef={this.props.saveFormRef}
        />
        <Loading isFetching={this.props.isFetching}/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./source/javascripts/pages/app.js